import Logo from "./../../assets/logo-login.svg";
import Button from "../../components/Buttons/Button";
import React, { FormEvent, useCallback, useEffect, useRef, useState } from "react";
import { secondary } from "../../theme";
import { Link } from "react-router-dom";
import { credentialsProps, useApi } from "../../hooks/api";
import { useForm } from "react-hook-form";
import { useGlobal } from "../../hooks/global";
import { IGroupProps } from "../../interfaces";
import { validateEmail } from "../../utils/validatesFields";
import { MagicButton } from "../../components/Buttons/MagicButton";
import { ModalLoading } from "../../components/Loadings/ModalLoading";
import {
  GenericForm,
  IGenericFormRefProps,
} from "../../components/GenericForm";
import {
  Content,
  ContainerBottomButtons,
  ContainerCheckBox,
  ContainerImage,
  ContainerTop,
  Form,
  Container,
  Description,
  LogoImg,
  ResetPasswordButton,
} from "./style";
import { Flex } from "@mantine/core";
import { useWallet } from "../../hooks/wallet";

export const Login: React.FC = () => {
  const { notify, theme, business } = useGlobal();
  const { signIn, remmemberCredentials, remmemberMe, setRemmemberMe } = useApi();
  const { searchSubscritpionUnlock } = useWallet();

  const params = new URLSearchParams(window.location.search);

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setError,
    setValue,
    trigger,
  } = useForm({
    defaultValues: remmemberCredentials as any,
    mode: "onChange",
  });

  const _form = watch();

  const form_ref = useRef<IGenericFormRefProps>(null);
  const buttonSubmitRef = useRef<HTMLButtonElement>(null);

  const onSubmit = useCallback(
    async (data: credentialsProps) => {
      localStorage.clear();
      setLoading(true);

      try {
        await signIn(data, remmemberMe);
        await searchSubscritpionUnlock({bus_id: business?.id});
      } catch (err: any) {
        const error = err.response ? err.response.data : "SERVER ERROR";

        if (error?.title === "Usuário não autorizado") {
          notify(error?.detail || '', 'error');
        }
        else if (error !== "SERVER ERROR" && err.response) {
          setError("email", {
            type: "manual",
            message: "Email ou senha incorreta",
          });
          setError("password", {
            type: "manual",
            message: "Email ou senha incorreta",
          });
        }
        else notify("ERRO INTERNO DO SISTEMA.", "error");
      }

      setLoading(false);
    },
    [remmemberMe, form_ref, _form]
  );

  const handleStopPropagation = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e?.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    [handleSubmit, onSubmit, form_ref, _form]
  );

  const changeRemmemberMe = useCallback(
    () => setRemmemberMe((atual) => !atual),
    []
  );

  const groups: IGroupProps[] = [
    {
      name: "",
      label: "",
      fields: [
        [
          {
            name: "email",
            label: "E-mail de acesso",
            type: "input",
            validate: validateEmail,
            required: true,
            noUpperCase: true,
          },
        ],
        [
          {
            name: "password",
            label: "Senha",
            type: "input",
            required: true,
            isPassword: true,
            noUpperCase: true,
          },
        ],
      ],
    },
  ];

  useEffect(() => {
    const email = params.get("email");
    const password = params.get("password");

    if (email && password) {
      window.history.replaceState(null, "", window.location.pathname);
      setValue('email', email)
      setValue('password', password)
      onSubmit({ email, password });
    }
  }, [params])

  return (
    <Container>
      <ContainerImage />

      <Content>
        <Flex mt='-20px' pl='30px' pb='30px'>
          <LogoImg src={Logo} height={38} />
        </Flex>

        <ContainerTop>
          <div style={{ fontSize: 24, fontWeight: 500, color: secondary[theme] }}>Bem-vindo de volta!</div>

          <Description>
            Entre com suas credenciais para acessar as <br /> funcionalidades da nossa plataforma.
          </Description>
        </ContainerTop>

        <Form onSubmit={handleStopPropagation}>
          <GenericForm
            ref={form_ref}
            groups={groups}
            _form={_form}
            control={control}
            trigger={trigger}
            errors={errors}
            setValue={setValue}
            register={register}
            noTrigger
          />

          <ContainerCheckBox>
            <MagicButton
              checked={remmemberMe}
              onClick={changeRemmemberMe}
              theme="light"
              type="checkbox"
              label="Lembrar meus dados"
              labelStyle={{
                textTransform: "none",
                fontWeight: 600,
                fontSize: 13,
              }}
            />

            <ResetPasswordButton>
              <Link
                to={"/reset-password"}
                style={{ fontWeight: "600", color: "#212529" }}
                children="Recuperar Senha"
              />
            </ResetPasswordButton>
          </ContainerCheckBox>

          <button
            ref={buttonSubmitRef}
            type="submit"
            style={{ display: "none" }}
          />
        </Form>

        <ContainerBottomButtons>
          <Button
            color="#FFF"
            background={secondary.light}
            onClick={() => buttonSubmitRef.current?.click()}
            style={{ fontSize: 15, padding: "8px 16px" }}
            children="Entrar"
          />

          <Link to={"/create-account"} style={{ textDecoration: "none", color: "#212529" }}>
            <Button
              color={secondary.light}
              background={"#FFF"}
              borderColor={secondary.light}
              style={{ fontSize: 15, fontWeight: 600, padding: "8px 16px" }}
              children="Experimente grátis"
            />
          </Link>
        </ContainerBottomButtons>
      </Content>

      <ModalLoading loading={loading} theme="light" />
    </Container>
  );
};
